import { Button, Modal } from "@nabble/ui";
import { RecoveryCodesPanel } from "../../../../components/RecoveryCodesPanel";

/** Shows freshly generated recovery codes; they can't be seen again once closed. */
export function NewRecoveryCodesDialog({ codes, onClose }: { codes: string[]; onClose: () => void }): React.JSX.Element {
  return (
    <Modal
      open
      icon="key"
      title="Your new recovery codes"
      description="Save them now: we won't show them again."
      onClose={onClose}
      actions={<Button label="I've saved them" onClick={onClose} />}
    >
      <RecoveryCodesPanel codes={codes} />
    </Modal>
  );
}
